import { FC, useEffect, useState } from "react";

import useHasAddressValuesChanged from "../hooks/useHasAddressValuesChanged";
import useUpdateAddress from "../hooks/useUpdateAddress";
import SubmitComponent from "./SubmitComponent";

const UpdateRecipient: FC = () => {
  const [isSaveSuccess, setIsSaveSuccess] = useState(false);

  const { isLoading, updateAddress } = useUpdateAddress();

  const { hasAddressValuesChanged, resetChangedState } = useHasAddressValuesChanged();

  // As this is form inside another form, we have to manually handle validation and data submit
  const handleSubmitAddress = async () => {
    const isSuccess = await updateAddress();
    setIsSaveSuccess(isSuccess);
  };

  useEffect(() => {
    const successTimeout = isSaveSuccess
      ? window.setTimeout(() => {
          resetChangedState();
          setIsSaveSuccess(false);
        }, 3000)
      : null;

    return () => {
      if (successTimeout !== null) {
        window.clearTimeout(successTimeout);
      }
    };
  }, [isSaveSuccess, resetChangedState]);

  // If none of the address values have been modified, save changes button should not be shown

  if (!hasAddressValuesChanged) {
    return null;
  }

  return (
    <SubmitComponent isUpdate isSaveSuccess={isSaveSuccess} isLoading={isLoading} onSubmit={handleSubmitAddress} />
  );
};
export default UpdateRecipient;
